export const InterviewType = {
  Online: 'online',
  InPerson: 'in-person',
  Call: 'call',
} as const;

export type InterviewType = (typeof InterviewType)[keyof typeof InterviewType];
